const getters = {
  token: (state) => state.user.token,
  systemName: (state) => state.user.systemName,
  // user_id: (state) => state.user.user_id,
};
export default getters;
